import React, { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { Divider, FormControl, FormHelperText, Tooltip} from '@material-ui/core';

import api from '../../utils/api';
import generateId from '../../utils/generateId';

import { LoadingButton } from '../CustomMui';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  fieldset: {
    // display: 'inline-block', // default of inline-flex doesn't work for fieldset
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  input: {
    display: 'none',
  },
  text: {
    marginTop: 20,
    fontSize: 14,
    color: '#000'
  },
  uploadButtonLabel: {
    width: 'auto',
  },
  button: {
    width: 175
  },
}));

export const PackageImport = React.memo((props) => {

  const [id] = useState(generateId('import-'));
  const history = useHistory();
  const classes = useStyles();
  const dirty = useSelector(state => state.dirty);
  const { id:intvId } = useParams();

  const uploadRef = useRef();

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (intvId) {
    return '';
  }

  // Handles uploading the file
  const onInputChange = (e) => {
    setLoading(true)
    
    var reader = new FileReader();

    // Assuming only file
    var file = uploadRef.current.files[0];

    if (!file) {
      return;
    }

    // var url = reader.readAsDataURL(file);
    reader.readAsDataURL(file);

    reader.onloadend = (e) => {
     
      const formData = new FormData()
      formData.append('File',file,file.name);

      // Send file upload to BE
      api.importInteractive(formData)
        .then(res => {
          history.push(`/${res.data.type}/${res.data.id}`, {dirty:false})
        })
        .catch(err => {
 
          if (err.response) {
            console.log(err.response)
          } else {
            console.log(err)
          }

          setError('An error occurred. Your file was not uploaded.')
        })
        .finally(() => {
          setLoading(false)
        })
      
    }
  }
  

  return (           
    <>     
      <FormControl component="fieldset" variant="outlined" className={classes.fieldset}>
        
        <input
          ref={uploadRef}
          accept=".zip"
          className={classes.input}
          id={id}
          type="file"
          onChange={onInputChange}
          aria-describedby={error ? `${id}-error` : ''}
        />
        
        <Tooltip title={dirty ? "Unable to import. Delete your draft to re-enable import." : ""}>

          <label htmlFor={id} className={classes.uploadButtonLabel}>
            <LoadingButton
              buttonProps={{
                color:"primary",
                component:"span",
                className:classes.button,
                disabled:dirty,
              }}
              loading={loading}
            >
              Import ZIP file
            </LoadingButton>
          </label>

        </Tooltip>
        

        {error
          ? <FormHelperText error id={`${id}-error`}>{error}</FormHelperText>
          : ''
        }

        <div className={classes.text}>
          To start from preexisting content or...
        </div>


      </FormControl>

      <Divider />
    </>
  )

})
